module.exports = __webpack_public_path__ + "img/sensor-triangle-exclamation.53320b37.svg";